import styled from "styled-components";

export const DeviceTrackingReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 82vw;
`;
